module.exports = __webpack_public_path__ + "img/table-graph-fp-overview.9cfe1692.svg";